import styled from 'styled-components';
import { breakpoints } from '../../constants';

export const Footer = styled.footer`
    font-size: 14px;
    text-align: center;
    padding: 0 20px 20px;
    line-height: 1.5;

    @media (${breakpoints.mediumMin}) {
        padding: 0 80px 20px;
    }
`;
